import axios from 'axios'
import { getInsidedData } from '@insided/destination/utils/insidedDataStorage'
import { Filters } from '@insided/deprecated-control/overview'
import { CustomProfileFieldList } from '@insided/deprecated-control/UserOverview/Columns'
import { getFilterParams } from '@insided/deprecated-control/UserOverview/Filters'

export const saveSegment = async (
  title: string,
  description: string,
  filters: Filters,
  customProfileFields: CustomProfileFieldList
) => {
  const user = getInsidedData('user')
  const payload = {
    title,
    description,
    filters: getFilterParams(filters, customProfileFields)
  }

  return await axios.post(`/users/segments/segments?userId=${user.userid}`, payload)
}
